import { dateSort } from "./dateSort";

const checkDateEqual = ({ a, b, column }) => {
  const aDateValue = a[column];
  const bDateValue = b[column];
  return aDateValue === bDateValue;
};

const sortData = ({
  transformedData,
  sortProperties = [],
  requiredArray = [],
}) => {
  if (requiredArray.length === 0) {
    return transformedData;
  }
  const sortCriteria = sortProperties;
  console.log(sortCriteria);
  console.log(sortProperties.length === 0);

  const dataCopy = [...transformedData];

  // Multi-level sort function
  const multiLevelSort = (a, b) => {
    for (let i = 0; i < sortCriteria.length; i++) {
      const { column, dataType, order, format, customOrder } = sortCriteria[i];
      console.log(column, dataType, order, format, customOrder);

      const aValue = a[column] === null ? "null" : a[column];
      const bValue = b[column] === null ? "null" : b[column];

      let comparison = 0;

      if (aValue === "null" && bValue === "null") {
        continue; // Both values are null, move to the next sorting criterion
      }
      if (aValue === "null") return order === "ASC" ? -1 : 1; // Null comes first/last based on order
      if (bValue === "null") return order === "ASC" ? 1 : -1;

      switch (dataType) {
        case "String":
          if (order === "CUSTOM" && Array.isArray(customOrder)) {
            const aIndex = customOrder.indexOf(aValue);
            const bIndex = customOrder.indexOf(bValue);
            // If not found in customOrder, put them at the end
            comparison =
              (aIndex === -1 ? customOrder.length : aIndex) -
              (bIndex === -1 ? customOrder.length : bIndex);
          } else {
            console.log(aValue, bValue);
            comparison =
              aValue !== undefined &&
              bValue !== undefined &&
              String(aValue).localeCompare(String(bValue));
            if (order === "DESC") {
              comparison *= -1;
            }
          }
          break;
        case "Number":
          if (order === "CUSTOM" && Array.isArray(customOrder)) {
            const aIndex = customOrder.indexOf(aValue);
            const bIndex = customOrder.indexOf(bValue);
            // Handle cases where values are not found in customOrder
            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            comparison = aIndex - bIndex;
          } else {
            comparison =
              aValue !== undefined && bValue !== undefined && aValue - bValue;
            if (order === "DESC") {
              comparison *= -1;
            }
          }
          break;
        case "Date":
          const isDateEqual = checkDateEqual({ a, b, column });
          if (isDateEqual) {
            continue;
          }

          comparison =
            dateSort([a, b], column, format, order, customOrder)[0] === a
              ? -1
              : 1;
          break;
        default:
          comparison = 0; // Default to no sorting if dataType is not recognized
          break;
      }

      if (comparison !== 0) {
        return comparison;
      }
    }

    return 0;
  };

  // Sort the data using the multi-level sort function
  dataCopy.sort(multiLevelSort);

  console.log(dataCopy);

  // Return the sorted data
  return dataCopy;
};

export { sortData };
